IREP.MeetTheTeam2 = (function () {   
    var init = function () {       
        if ($(".memberSquare > .MTTcontent :first").hasClass('addMember')) //if user is an admin
        {
            $(".memberSquare > .MTTcontent :nth(3)").click();
        }
        else {
            $(".memberSquare > .MTTcontent :first").click();
        }        
    }

    // ADD NEW MEMBERS

    $("#cancelNewGuy").click(function () {
        $("#lightbox").hide();
        $("body").css({ "overflow": "auto" });
    });

    $("#saveNewGuy").click(function () {        
        var data = {
            participantid: $("#userPicker").val(),
            title: "New Guy",
            bio: "Bio",
            active: false,
            allowEmail: false,
            email: null,
            image: null,
            id:-1
        };
        IREP.callApi({ url: 'meettheteam/UpdateMember', type: 'POST', data: data }).done(function (data) {
            $("#MTCImageWrapper").append('<div id="editHoverWrapper"><div id="editHover"></div></div>');
            $("#MTCName").html(data.member.name);
            $("#CurrentMemberName").html(data.member.name);
            $("#MTCTitle").html(data.member.title);
            $("#MTTTitle").val(data.member.title);
            $("#MTCBio").html(data.member.bio);
            $("#MTTBio").val(data.member.bio);
            $(".save").attr({ "data-id": data.member.id });
            $("#deleteBtn").attr({ "data-id": data.member.id });
            $("#memberID").val(data.member.id);
            $("#memberID").attr({ "paxuid": data.member.paxuid });
            $("#memberImage").attr({ "src": IREP.options.appUrl + "content/images/MeetTheTeam/v2/avatar-block-gray.jpg" });
            $("#MTCImageWrapper img").attr({ "Src": IREP.options.appUrl + "content/images/MeetTheTeam/v2/avatar-block-gray.jpg" });          
            $("#MTTActive").prop('checked', false);         
            $("#MTTEmailMe").prop('checked', false);            
            $("#MTTEmail").val('');
            $("#MTTBand").slideDown(500);           
            $("#showLinkEdit, #showTrainingEdit, #showStatusEdit").css({ "display": "inline-block" });
            $("#lightbox").hide();
            $("body").css({ "overflow": "scroll" });
            $("#editHoverWrapper").click();           
           
        });
    });


    $("#searchEmail").on("focusout", function () {
        $("#userPicker").find('option').remove();
        $("#userPicker").attr({ "disabled": "disabled" });
        
        var data = {
            Email: $("#searchEmail").val(),
        };

        //this currently does not look anyone up, functionality will have to be set up
        IREP.callApi({ url: 'participant/lookupParticipantByEmail', type: 'GET', data: data }).done(function (data) {
            if (data.participant !== undefined)
            {
                $("#userPicker").append('<option value="' + data.participant.participantId + '" >' + data.participant.name + ' - ' + data.participant.userName + '</option>');

                $("#userPicker").removeAttr("disabled");
                $("#userPicker").val(data.participant.participantId);
            }
           
        });
    });

    // SELECT CURRENT MEMBER

    $("div").on("click", ".MTTcontent", function () {
        var newID = $(this).attr("id");
        if (newID == -2 || newID == undefined || newID == 0) {
            return;
        }
        //$(".activityList").fadeOut();
     //   $("#MTTBand").slideUp(500, function () {
            $("#MTTEdit").hide();
            $("#MTCBandWrapper").show();
            if (newID == -1) {
                // adding a new member
                $("#newGuyWrapper").show();
                $("#errorWrapper").hide();
                $("#lightbox").show();
                $("body").css({ "overflow": "hidden" });
                $("#lightbox").css({ "top": $("#MeetTheTeam").offset().top + "px" } );
                // show the lightbox with the email search box

            } else {                
                IREP.callApi({ url: 'meettheteam/getMember', type: 'GET', data: { id: newID } }).done(function (data) {                    
                    $("#tooManyTrainings").hide();
                    $(".addTrainingRow ").show();
                    $("#MTCName").html(data.teamMember.name);
                    $("#CurrentMemberName").html(data.teamMember.name);
                    $("#MTCTitle").html(data.teamMember.title);
                    $("#MTTTitle").val(data.teamMember.title);
                    $("#MTCBio").html(data.teamMember.bio);
                    $("#MTTBio").val(data.teamMember.bio);
                    $(".save").attr({ "data-id": newID });
                    $("#deleteBtn").attr({ "data-id": newID });
                    $("#memberID").val(newID);
                    $("#memberID").attr({ "paxuid": data.teamMember.paxuid });
                    if (data.teamMember.image) {
                        $("#memberImage").attr({ "src": "data:image/gif;base64," + data.teamMember.image });
                        $("#MTCImageWrapper img").attr({ "src": "data:image/gif;base64," + data.teamMember.image });
                    } else {
                        if (IREP.options.user.site === "EMEA")
                        {
                            $("#memberImage").attr({ "src": "/content/images/EMEA/201608/MeetTheTeam/avatar-block-EMEA.jpg" });
                            $("#MTCImageWrapper img").attr({ "Src": "/content/images/EMEA/201608/MeetTheTeam/avatar-block-EMEA.jpg" });
                        }
                        else {
                            $("#memberImage").attr({ "src": IREP.options.appUrl + "content/images/MeetTheTeam/v2/avatar-block-gray.jpg" });
                            $("#MTCImageWrapper img").attr({ "Src": IREP.options.appUrl + "content/images/MeetTheTeam/v2/avatar-block-gray.jpg" });
                        }
                       
                    }                   
                    if (data.teamMember.active) {
                        $("#MTTActive").prop('checked', true);
                    } else {
                        $("#MTTActive").prop('checked', false);
                    }
                    //if (data.teamMember.allowEmail) {     
                    //    $("#MTTEmailMe").prop('checked', true);
                    //    $("#MTTEmail").removeAttr("disabled");
                    //} else {
                    //    $("#MTTEmailMe").prop('checked', false);
                    //    $("#MTTEmail").attr({"disabled": "disabled" });
                    //}

                    if (data.teamMember.teamAdmin) {
                        $("#MTTTeamAdmin").prop('checked', true);
                    } else {
                        $("#MTTTeamAdmin").prop('checked', false);
                    }
                    $("#MTTEmail").val((data.teamMember.email) ? data.teamMember.email : '');
                   // $("#MTTBand").slideDown(500);
                    if ($("#isTeamAdmin").val() || IREP.options.user.currentUID == data.teamMember.paxuid) {
                        $("#showLinkEdit, #showTrainingEdit, #showStatusEdit").css({ "display": "inline-block" });
                        $("#editHoverWrapper").remove();
                        $("#MTCImageWrapper").append('<div id="editHoverWrapper"><div id="editHover"></div></div>');
                    } else {
                        $("#showLinkEdit, #showTrainingEdit, #showStatusEdit").hide();
                        $("#editHoverWrapper").remove();
                    }
                    if ($("#isTeamAdmin").val()) {
                        // only show the teamAdmin item if the current user is teamadmin
                        $("#teamAdminRow").show();
                    } else {
                        $("#teamAdminRow").hide();
                    }
                    reloadStatus($.grep(data.activity, function (e) { return e.activityTypeId == 1 }));
                    reloadLinks($.grep(data.activity, function (e) { return e.activityTypeId == 2 }));
                    reloadTrainings($.grep(data.activity, function (e) { return e.activityTypeId == 3 }));

                });
            }
       // });    
    });

    var reloadStatus = function (statuses) {
       
        if (statuses.length > 0 || IREP.options.user.currentUID == $("#memberID").attr("paxuid") || $("#isTeamAdmin").val()) {
            $(".statusList").show();
        } else {
            $(".statusList").hide();
        }

        $(".statusRow").remove();

        $.each(statuses, function (key, value) {
            var newRow = '<div class="statusRow" id="statusRow' + value.id + '"><div class="statusMain"><div class="status">' + value.details + '</div><div class="statusDate">' + moment(new Date(value.createdDate)).format('L') + '</div></div>'
                                + '<div class="statusEdit" style="display:none;"><div class="statusDeleteBtn" data-id="' + value.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>'
                                + '<div class="statusEditBtn"  data-id="' + value.id + '" data-status="' + value.details + '" ><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/edit-icon-small-lt-gray.png" /></div></div></div>';
            $("#statusRows").append(newRow);
        });

    };

    var reloadLinks = function (links) {

        if (links.length > 0 || IREP.options.user.currentUID == $("#memberID").attr("paxuid") || $("#isTeamAdmin").val()) {
            $(".favoriteLinks").show();
        } else {
            $(".favoriteLinks").hide();
        }

        $(".favoriteLinksRow").remove();

        $.each(links, function (key, value) {
            var newRow = '<div class="favoriteLinksRow" id="linkRow' + value.id + '">'
                               + '<div class="linksEdit" style="display:none;"><div class="linkDelete" data-id="' + value.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>'
                               + '<div class="linkEdit"  data-id="' + value.id + '"  data-title="' + value.title + '" data-url="' + value.details + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/edit-icon-small-lt-gray.png" /></div></div>'
                               + '<a href="' + value.details + '" id="link' + value.id + '">' + value.title + '</a></div>';
            $("#linkRows").append(newRow);
        });
    };

    var reloadTrainings = function (trainings) {

        if (trainings.length > 0 || IREP.options.user.currentUID == $("#memberID").attr("paxuid") || $("#isTeamAdmin").val()) {
            $(".trainingList").show();
            $(".defaultTrainingList").hide();
        } else {
            $(".trainingList").hide();
            $(".defaultTrainingList").show();
        }
        
        $(".trainingRow").remove();

        $.each(trainings, function (key, value) {            
            
            var newRow = '<div class="trainingRow" id="trainingRow' + value.id + '">' +                            
                            '<a href="learning?actcode=' + value.details + '&al=1">' +
                                '<div class="trainingRowWrapper ">' +
                                    '<div class="trainingImage ">' +
                                        '<div class="trainingImageWrapper leftBox">' +
                                            '<img src="/content/images/Learning/' + value.details + '.jpg" />' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="trainingInfo">' +
                                        '<div class="trainingTitle">' + value.training.name + '</div>' +
                                        '<div class="trainingDescription">' +/* (value.training.description.length > 200 ? value.training.description.substr(0, 200) + '...' : */value.training.description /*)*/ + '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</a>' +
                            '<div class="trainingEdit" style="display:none;">' +
                                '<div class="trainingDelete" data-id="' + value.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>' +
                            '</div>' +
                        '</div>';

            $("#trainingRows").append(newRow);
        });

    };
    

    $("#closeError").click(function () {
        $("#lightbox").hide();
        $("#newGuyWrapper").show();
        $("#errorWrapper").hide();
        $("#errMessage").html("");        
    });


   /* // EMAIL US

    $("#emailUsSubmitButton").click(function () {        
        // validate the email address is valid-ish
        if (/(.+)@(.+){2,}\.(.+){2,}/.test($("#email").val()) == false) {

            $("#newGuyWrapper").hide();
            $("#errorWrapper").show();
            $("#errMessage").html("Please enter a valid Email Address");
            
            $("#lightbox").show();
            $("body").scrollTop(0);
            return;
        }

        if ($('#toAddr option:selected').text() == undefined || $('#toAddr option:selected').text() == "")
        {
            $("#newGuyWrapper").hide();
            $("#errMessage").html("Please enter a valid Email Address");
            $("#lightbox").show();
            $("#errorWrapper").show();
            $("body").scrollTop(0);
            return;
        }

        var emailBody = " From: " + IREP.options.user.firstName + ' ' + IREP.options.user.lastName  + " (" + $("#email").val() + ") \n Message: " + $("#emailBody").val();
        var data = {
            fromAddr: "retailedgesupport-noreply@intel.com",
            fromName: IREP.options.user.firstName + ' ' + IREP.options.user.lastName,
            toAddr: $("#toAddr").val(),
            toName: $("#toAddr option:selected").text(),
            message: emailBody
        };
        
        IREP.callApi({ url: 'meettheteam/SendEmail', type: 'GET', data: data }).done(function (data) {
            $("#emailForm").hide();
            $("#thankYouPage").show();
        });
        
    }); */

    $("#closeBtn").click(function () {
        $("#emailBody").val("");
        $("#emailForm").show();
        $("#thankYouPage").hide();
    });


    // EDIT MEMBER

    $(".cancel").click(function () {
        window.location.href = window.location.href;
        $("#MTTEdit").slideUp(400, function () {
            $("#MTCBandWrapper").slideDown(400);
        });
    });

    // the actual file selector is hidden
    $(".changeImage").click(function () {
        $("#file").click();
    });
    
    $("#deleteBtn").click(function () {
        var id = $(this).attr("data-id");
        if (confirm("You are a about to delete this team member and all their statuses, recomended trainings, and links. Are you sure?")) {
            IREP.callApi({ url: 'meettheteam/DeleteMember', type: 'POST', data: { id: id } }).done(function (data) {
                window.location.href = window.location.href;
            });
        }
    });
    
    $("div").on("click", "#editHoverWrapper", function () {
        $("#MTCBandWrapper").slideUp(400, function () {
            $("#MTTEdit").slideDown(400); // .css({"min-height":"300px"});
        });

    });

    // STATUSES
    
    $("#showStatusEdit").click(function () {

        if ($(".statusRow").length >= 10) {
            $("#tooManyStatues").show();
            $("#statusForm").hide();
        } else {
            $("#tooManyStatues").hide();
            $("#statusForm").show();
        }
        $("#addStatus").slideToggle();
        $(".statusEdit").slideToggle();
    });

    $(".statusEditBtn").click(function () {
        var id = $(this).attr("data-id");
        var status = $(this).attr("data-status");
        $("#addStatus").slideUp(300, function () {
            $("#statusId").val(id);
            $("#newStatus").val(status);
        });
        $("#addStatus").slideDown();
    });

    $("#cancelStatusBtn").click(function () {
        $("#addStatus").slideUp();
        $("#statusId").val("-1");
        $("#newStatus").val("");
        $(".statusEdit").slideUp();
    });

    $("#addStatusBtn").click(function () {
        var data = {
            id: $("#statusId").val(),
            title: null,
            details: $("#newStatus").val(),
            activityTypeId: 1,
            teamMemberId: $("#memberID").val()
        };
        IREP.callApi({ url: 'meettheteam/UpdateActivity', type: 'POST', data: data }).done(function (data) {

            if ($("#statusId").val() == -1) {
                var newRow = '<div class="statusRow" id="statusRow' + data.activity.id + '"><div class="statusMain"><div class="status">' + data.activity.details + '</div><div class="statusDate">' + moment(new Date(data.activity.createdDate)).format('L') + '</div></div>'
                            + '<div class="statusEdit" style="display:none;"><div class="statusDeleteBtn" data-id="' + data.activity.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>'
                            + '<div class="statusEditBtn"  data-id="' + data.activity.id + '" data-status="' + data.activity.details + '" ><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/edit-icon-small-lt-gray.png" /></div></div></div>';
                $("#statusRows").prepend(newRow);
            } else {
                $("#status" + data.activity.id).html(data.activity.details);
                $(".statusEditBtn[data-id='" + data.activity.id + "']").attr({ "data-status": data.activity.details });
            }
            $("#cancelStatusBtn").click();
        });
    });

    $("div").on("click", ".statusDeleteBtn", function () {
        var deleteId = $(this).attr("data-id");
        var data = {
            id: deleteId
        };
        IREP.callApi({ url: 'meettheteam/DeleteActivity', type: 'POST', data: data }).done(function (data) {
            $("#statusRow" + deleteId).remove();

            $("#cancelStatusBtn").click();
        });
    });

    // RECOMENDED TRAININGS

    $("#searchTitle").keyup(function () {

        $(".loadingHover").show();
        $("#searchlist").find('option').remove();
        $("#searchlist").attr({ "disabled": "disabled" });

        var data = {
            Query: $("#searchTitle").val(),
            PageNumber: 1,
            PageSize: 100,
            SearchFilter: 0,
            SiteCollection: IREP.options.user.geoCode
        };
        IREP.callApi({ url: 'activity/search', type: 'GET', data: data }).done(function (data) {

            $.each(data.searchResults.items, function (index, value) {
                $("#searchlist").append('<option value="' + value.activityCode + '" data-description="' + value.description + '">' + moment(value.createdDate).format("L") + " - " + value.name + '</option>');
            });
            $("#searchlist").removeAttr("disabled");
            $("#searchlist").val(data.searchResults.items[0].activityCode);
            $("#newTrainingThumb").attr({ "src": "/content/images/Learning/" + data.searchResults.items[0].activityCode + ".jpg" });
            $(".loadingHover").hide();
        });
    });
    
    $("#searchlist").change(function () {
        $("#newTrainingThumb").attr({ "src": "/content/images/Learning/" + $(this).val() + ".jpg" });
    });


    $(".addHover").click(function () {
        if ($("#searchlist").val() != "") {
            var data = {
                id: -1,
                title: null,
                details: $("#searchlist").val(),
                activityTypeId: 3,
                teamMemberId: $("#memberID").val()
            };
            IREP.callApi({ url: 'meettheteam/UpdateActivity', type: 'POST', data: data }).done(function (data) {

                var val = $("#searchlist option:selected").text();

                var newRow = '<div class="trainingRow" id="trainingRow' + data.activity.id + '">' +
                            '<a href="learning?actcode=' + data.activity.details + '&al=1">' +
                                '<div class="trainingRowWrapper ">' +
                                    '<div class="trainingImage ">' +
                                        '<div class="trainingImageWrapper leftBox">' +
                                            '<img src="/content/images/Learning/' + data.activity.details + '.jpg" />' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="trainingInfo">' +
                                        '<div class="trainingTitle">' + val.substr(val.indexOf("-") + 2) + '</div>' +
                                        '<div class="trainingDescription">' + $("#searchlist option:selected").attr("data-description").substr(0, 200) + '...</div>' +
                                    '</div>' +
                                '</div>' +
                            '</a>' +
                            '<div class="trainingEdit" style="display:none;">' +
                                '<div class="trainingDelete" data-id="' + data.activity.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>' +
                            '</div>' +
                        '</div>';
                $("#trainingRows").prepend(newRow);
                $("#addTraining").slideUp();
                $(".trainingEdit").slideUp();
                $("#searchlist").find('option').remove();
                $("#searchTitle").val("").blur();
                $("#newTrainingThumb").attr({ "src": IREP.options.appUrl + "content/images/meettheteam/v2/add-learning-thumb.jpg" });
                $("#searchlist").attr({ "disabled": "disabled" });

            });
        }
    });
    
    $("#showTrainingEdit").click(function () {

        if ($(".trainingRow").length >= 10) {
            $("#tooManyTrainings").show();
            $(".addTrainingRow ").hide();
        } else {
            $("#tooManyTrainings").hide();
            $(".addTrainingRow ").show();
        }

        $("#addTraining").slideToggle();
        $(".trainingEdit").slideToggle();
    });

    $("div").on("click", ".trainingDelete", function () {
        var deleteId = $(this).attr("data-id");
        var data = {
            id: deleteId
        };
        IREP.callApi({ url: 'meettheteam/DeleteActivity', type: 'POST', data: data }).done(function (data) {
            $("#trainingRow" + deleteId).remove();

            $("#addTraining").slideUp();
            $(".trainingEdit").slideUp();
            $("#searchlist").find('option').remove();
            $("#searchTitle").val("").blur();
            $("#newTrainingThumb").attr({ "src": IREP.options.appUrl + "content/images/meettheteam/v2/add-learning-thumb.jpg" });
            $("#searchlist").attr({ "disabled": "disabled" });
        });
    });

    // FAVORITE LINKS
    
    $("#showLinkEdit").click(function () {

        if ($(".favoriteLinksRow").length >= 10) {
            $("#tooManyLinks").show();
            $("#linkForm").hide();
        } else {
            $("#tooManyLinks").hide();
            $("#linkForm").show();
        }

        $("#addLink").slideToggle();
        $(".linksEdit").slideToggle();
    });

    $(".linkEdit").click(function () {
        var id = $(this).attr("data-id");
        var url = $(this).attr("data-url");
        var title = $(this).attr("data-title");
        $("#addLink").slideUp(300, function () {
            $("#linkId").val(id);
            $("#linkTitle").val(title);
            $("#linkURL").val(url);
        });
        $("#addLink").slideDown();
    });

    $("#cancelLinkBtn").click(function () {
        $("#addLink").slideUp();
        $("#linkId").val("-1");
        $("#linkTitle").val("");
        $("#linkURL").val("");
        $(".linksEdit").slideUp();
    });

    $("#addLinkBtn").click(function () {
        var data = {
            id: $("#linkId").val(),
            title: $("#linkTitle").val(),
            details: $("#linkURL").val(),
            activityTypeId: 2,
            teamMemberId: $("#memberID").val()
        };
        IREP.callApi({ url: 'meettheteam/UpdateActivity', type: 'POST', data: data }).done(function (data) {

            if ($("#linkId").val() == -1) {
                var newRow = '<div class="favoriteLinksRow" id="linkRow' + data.activity.id + '">'
                            + '<div class="linksEdit" style="display:none;"><div class="linkDelete" data-id="' + data.activity.id + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/delete-icon.png" /></div>'
                            + '<div class="linkEdit"  data-id="' + data.activity.id + '"  data-title="' + data.activity.title + '" data-url="' + data.activity.details + '"><img src="' + IREP.options.appUrl + 'content/images/meettheteam/v2/edit-icon-small-lt-gray.png" /></div></div>'
                            + '<a href="' + data.activity.details + '" id="link' + data.activity.id + '">' + data.activity.title + '</a></div>';
                $("#linkRows").prepend(newRow);
            } else {
                $("#link" + data.activity.id).attr({ "href": data.activity.details }).text(data.activity.title);
                $(".linkEdit[data-id='"+ data.activity.id + "']").attr({ "data-url": data.activity.details, "data-title": data.activity.title });
            }
            $("#cancelLinkBtn").click();
        });
    });

    $("div").on("click", ".linkDelete", function () {
        var deleteId = $(this).attr("data-id");
        var data = {
            id: deleteId
        };
        IREP.callApi({ url: 'meettheteam/DeleteActivity', type: 'POST', data: data }).done(function (data) {
            $("#linkRow" + deleteId).remove();

            $("#cancelLinkBtn").click();
        });
    });



    // IMAGE CROPPING

    var showCropper = function () {
        $("#dvUploadButtonHolder").hide();

        //Remove existing dynamic items if found. (Needed for close & re-open overlay)
        $("#uploadedImage").remove();
        $(".jcrop-holder").remove();
        $(".innerPreview").remove();

        $("#dvUploadedImage").append($("<img id='uploadedImage' class='uploadedImage' style='width:500px;'>").attr('src', $('#memberImage').attr('src')));

        $("#uploadedImage").bind("load", function () {
            //When the appended element has finished loading, then we want to show the cropper and link it to the uploaded image. 
            // If you do it before, then the 
            $(".image-cropper").show();
            $('.image-cropper').each(linkUp);
        });
        $("#dvUploadedImage").show();
        $("#lightbox").show();
        $("#newGuyWrapper").hide();
        $("#errorWrapper").hide();
    };

    $("#btnUploadImage").on("click", function () {
        $(".image-cropper").hide();
        var img = $(".innerPreview").find('img').attr("src");
        
        $("#croppedImage").val(img);
        $("#memberImage").attr("src", img );
        $("#lightbox").hide();
    });

    $("#dvCloseUploadButton2").on("click", function () {
        $("#dvPsOverlayHolder").hide();
        $("#lightbox").hide();
        $(".image-cropper").hide();
    });


    function linkUp(unusedIndex, container) {
        container = $(container); //We were passed a DOM reference, convert it to a jquery object

        //The code will look for a img.image, a div.preview, a.result, an input.result inside the specified container, and link them together.
        //Only 'img.image' is required, however.  

        //Find the original image
        var image = container.find("img#uploadedImage");

        //Find the aspect ratio of the image
        var targetRatio = $(".croppedPreview").width() / $(".croppedPreview").height();
        var keepRatio = true;

        //jCrop will enforce this ratio:
        var forcedRatio = keepRatio ? targetRatio : null;

        //Find the URL of the original image minus the querystring.
        var path = image.attr('src');
        if (path.indexOf('?') > 0) path = path.substr(0, path.indexOf('?'));

        //Find the preview div(s) (if they exist) and make sure the have a set height and width.
        var divPreview = container.find("div.croppedPreview");

        //What size to make the preview window (defaults to existing width/height if specified in 'style' attribute)
        var previewFallbackWidth = 160;
        var previewFallbackHeight = 160;

        //Allow the div to override the default width and height in the style attribute
        var previewMaxWidth = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('width') > -1) ? divPreview.width() : previewFallbackWidth;
        var previewMaxHeight = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('height') > -1) ? divPreview.height() : previewFallbackHeight;
        //Set the values explicitly.
        divPreview.css({
            width: previewMaxWidth + 'px',
            height: previewMaxHeight + 'px',
            overflow: 'hidden'
        });

        //Create another child div and style it to form a 'clipping rectangle' for the preview div.
        var innerPreview = $('<div />').css({
            overflow: 'hidden'
        }).addClass('innerPreview').appendTo(divPreview);

        //Create a copy of the image inside the inner preview div(s)
        $('<img />').attr('src', image.attr('src')).appendTo(innerPreview);

        //And any input fields (for postbacks, if desired)
        var inputs = container.find('input.result');


        //Create a function to update the link, hidden input, and preview pane
        var update = function (coords) {
            if (parseInt(coords.w) <= 0 || parseInt(coords.h) <= 0) return; //Require valid width and height

            //The aspect ratio of the cropping rectangle. If 'keepRatio', use targetRatio since it's more precise.
            var cropRatio = keepRatio ? targetRatio : (coords.w / coords.h);

            //When the selection aspect ratio changes, the preview clipping area has to also.
            //Calculate the width and height.
            var innerWidth = cropRatio >= (previewMaxWidth / previewMaxHeight) ? previewMaxWidth : previewMaxHeight * cropRatio;
            var innerHeight = cropRatio < (previewMaxWidth / previewMaxHeight) ? previewMaxHeight : previewMaxWidth / cropRatio;

            innerPreview.css({
                width: Math.ceil(innerWidth) + 'px',
                height: Math.ceil(innerHeight) + 'px',
                marginTop: (previewMaxHeight - innerHeight) / 2 + 'px',
                marginLeft: (previewMaxWidth - innerWidth) / 2 + 'px',
                overflow: 'hidden'
            });

            //Calculate how much we are shrinking the image inside the preview window
            var scalex = innerWidth / coords.w;
            var scaley = innerHeight / coords.h;

            //Set the width and height of the image so the right areas appear at the right scale appear.
            innerPreview.find('img').css({
                width: Math.round(scalex * image.width()) + 'px',
                height: Math.round(scaley * image.height()) + 'px',
                marginLeft: '-' + Math.round(scalex * coords.x) + 'px',
                marginTop: '-' + Math.round(scaley * coords.y) + 'px'
            });


            innerWidth = cropRatio >= 1 ? 100 : 100 * cropRatio;
            innerHeight = cropRatio < 1 ? 100 : 100 / cropRatio;
            scalex = innerWidth / coords.w;
            scaley = innerHeight / coords.h;
            //Set the width and height of the thumbnail image on the edit page in the background
            $("#memberImage").css({
                width: Math.round(scalex * image.width()) + 'px',
                height: Math.round(scaley * image.height()) + 'px',
                marginLeft: '-' + Math.round(scalex * coords.x) + 'px',
                marginTop: '-' + Math.round(scaley * coords.y) + 'px'
            });

            //Calculate the querystring
            var query = '';

            //Add final size, if specified.
            query += 'maxwidth=' + $(".croppedPreview").width() + '&';
            query += 'maxheight=' + $(".croppedPreview").height() + '&';

            //Add crop rectangle
            query += 'crop=(' + coords.x + ',' + coords.y + ',' + coords.x2 + ',' + coords.y2 + ')&cropxunits=' + image.width() + '&cropyunits=' + image.height();
            
            //Now, update the links and input values.
            //links.attr('href', "PhotoShareSubmission?name=" + path + query);
            //links.attr('target', '_blank');
            $("#txtRequestString").val(query);
            inputs.attr('value', path + '&' + query);
        };


        //Preview window initialization. Based on the aspect ratio, do the initial selection. 
        var sourceRatio = image.width() / image.height();
        var newWidth = divPreview.width();
        var newHeight = divPreview.height();
        var startX = 0;
        var startY = 0;

        //Our viewing area is 300x200. If the ratio of the source image is smaller, then we calculate the display area based on the image width. 
        //      Otherwise, we calculate based on image height. We want to maximize our selection as much as possible. 
        //      X = TargetRatio * Y. 
        if (targetRatio > sourceRatio) {
            newWidth = image.width();
            newHeight = image.width() / targetRatio; //Divide by the ratio because the ratio is width based and we're calculating the Y off the X.
            startX = 0; //We have all the width of the image. Height is the variable
            startY = (image.height() - newHeight) / 2; //Center the crop area.
        }
        else {
            newWidth = image.height() * targetRatio; //Multiply by the ratio because the ratio is width based and we're calculating the X off the Y. 
            newHeight = image.height();
            startX = (image.width() - newWidth) / 2;
            startY = 0; //We have all the height of the image. Width is the variable
        }

        //Start up jCrop
        var jcrop_reference = $.Jcrop(image);
        jcrop_reference.setOptions({
            onChange: update,
            onSelect: update,
            aspectRatio: forcedRatio,
            bgColor: 'black',
            bgOpacity: 0.6
        });

        jcrop_reference.setSelect([startX, startY, newWidth + startX, newHeight + startY]); //Set the initial selection window.
    };

    // SCROLLING FUNCTIONS

    $("#rightScroll").click(function () {

        scrollRight("row1");
        scrollRight("row2");
        scrollRight("row3");

    });

    $("#rightScroll-two").click(function () {

        scrollRight("row1");
        scrollRight("row2");
        scrollRight("row3");

    });

    $("#rightScroll-one").click(function () {

        scrollRight("row1");
        scrollRight("row2");
        scrollRight("row3");

    });

    var scrollRight = function (id) {
        var one = $("#" + id + " .scroller .MTTItem").eq(0);
        var two = $("#" + id + " .scroller .MTTItem").eq(1);

        one.animate({ width: 'toggle' }, function () { one.remove().appendTo("#" + id + " .scroller").css({ width: '152px' }).show(); });
        two.animate({ width: 'toggle' }, function () { two.remove().appendTo("#" + id + " .scroller").css({ width: '152px' }).show(); });

        //   one.remove().appendTo("#" + id + " .scroller").css({ width : '162px' });        
        //   two.remove().appendTo("#" + id + " .scroller").css({ width : '162px' });

    }

    $("#leftScroll").click(function () {
        //scroll each row three items
        scrollLeft("row1");
        scrollLeft("row2");
        scrollLeft("row3");
    });

    $("#leftScroll-two").click(function () {
        //scroll each row three items
        scrollLeft("row1");
        scrollLeft("row2");
        scrollLeft("row3");
    });

    $("#leftScroll-one").click(function () {
        //scroll each row three items
        scrollLeft("row1");
        scrollLeft("row2");
        scrollLeft("row3");
    });

    var scrollLeft = function (id) {
        var one = $("#" + id + " .scroller .MTTItem").eq($("#" + id + " .scroller .MTTItem").length-1);
        var two = $("#" + id + " .scroller .MTTItem").eq($("#" + id + " .scroller .MTTItem").length - 2);

        one.css({ width: '0' });        
        two.css({ width: '0' });

        one.remove().prependTo("#" + id + " .scroller").animate({ width: '152px' });
        two.remove().prependTo("#" + id + " .scroller").animate({ width: '152px' });
    }

    // WATERMARK TEXT_BOXES

    $(".watermark").focus(function () {
        if ($(this).val() == $(this).attr("data-default")) {
            $(this).val("");
            $(this).removeClass("default");
        }
    });

    $(".watermark").blur(function () {
        if ($(this).val() == "") {
            $(this).val($(this).attr("data-default"));
            $(this).addClass("default");
        }
    });

    return {
        init: init,
        showCropper: showCropper
    };
})();